<div class="ui-modal"
     [formGroup]="form">
    <div class="header flex-row space-between-center">
        {{'FLOW_CHART.NODES.WEBHOOK.NAME'|translate}}
        <span class="ui-icon-close c-p"
              mat-dialog-close>
        </span>
    </div>
    <div class="body">
        <div class="flex-col gap-16">
            <div class="flex-col gap-8">
                <label>{{ 'WEBHOOK_DIALOG.NAME'|translate }} <span class="required">*</span></label>
                <input class="ui-input ui-input-40"
                       [placeholder]="'WEBHOOK_DIALOG.PLACEHOLDERS.NAME'|translate"
                       formControlName="name">
            </div>

            <div class="flex-col gap-8 w-100">
                <label>{{ 'WEBHOOK_DIALOG.METHOD'|translate }} <span class="required">*</span></label>
                <mat-select class="ui-selector ui-selector-40"
                            formControlName="method">
                    <mat-select-trigger class="select-trigger">
                        {{ httpMethodsMap[form.get('method').value] }}
                    </mat-select-trigger>
                    @for( option of httpOptions; track option) {
                    <mat-option [value]="option">{{ httpMethodsMap[option] }}</mat-option>
                    }
                </mat-select>
            </div>
            
            @let webhook = webhookSig();
            @if(webhook) {
                <div class="flex-col gap-8 w-100">
                    <label>{{ 'WEBHOOK_DIALOG.URL'|translate }}</label>

                    <div class="flex-row start-center gap-8">
                        <input disabled
                            class="ui-input ui-input-40 w-100"
                            [value]="webhook.url">
                        <ui-copy-clipboard class="c-p"
                                        #clipboard
                                        [copyContent]="webhook.url"
                                        (click)="clipboard.copyContent">
                        </ui-copy-clipboard>
                    </div>
                </div>
            }

            <div class="flex-row start-center tabs gap-24">
                <div [class.selected]="selectedTabSig() === webhookTabs.QueryParams"
                     (click)="selectedTabSig.set(webhookTabs.QueryParams)">{{
                    'WEBHOOK_DIALOG.QUERY_PARAMS'|translate }}
                </div>
                <div [class.selected]="selectedTabSig() === webhookTabs.Authorization"
                     (click)="selectedTabSig.set(webhookTabs.Authorization)">{{
                    'WEBHOOK_DIALOG.AUTHORIZATION'|translate }}
                </div>
                <div [class.disabled]="form.get('method').value === httpMethods.GET"
                     [class.selected]="selectedTabSig() === webhookTabs.Body"
                     (click)="selectedTabSig.set(webhookTabs.Body)">{{ 'WEBHOOK_DIALOG.BODY'|translate }}
                </div>
                <div [class.selected]="selectedTabSig() === webhookTabs.Options"
                     (click)="selectedTabSig.set(webhookTabs.Options)">
                    {{ 'WEBHOOK_DIALOG.OPTIONS'|translate }}
                </div>
            </div>
        </div>

        <div>
            @switch(selectedTabSig()) {
            @case(webhookTabs.QueryParams) {
            <app-params-table [paramsControls]="getQueryParamsControls"
                              (onDeleteParams)="deleteQueryParams($event)"
                              (onAddParams)="addQueryParams()">
            </app-params-table>
            }
            @case(webhookTabs.Authorization) {
            <div class="flex-col h-100 w-100 gap-8 mt-16">
                <div class="flex-row auth-selector">
                    <mat-select class="ui-selector"
                                formControlName="auth"
                                (selectionChange)="changeAuthFormOnSelect($event)">
                        @for(type of authTypesOptions; track type) {
                        <mat-option [value]="type">
                            {{ authTypesMap[type]|translate }}
                        </mat-option>
                        }
                    </mat-select>
                </div>
                <ng-container [formGroup]="$any(form.get('credential'))">
                    @switch(form.get('auth').value) {
                    @case(authTypes.BASIC) {
                    <div class="flex-row start-center gap-8">
                        <input class="ui-input flex"
                               [placeholder]="'WEBHOOK_DIALOG.PLACEHOLDERS.USERNAME'|translate"
                               formControlName="username">
                        <input class="ui-input flex"
                               [placeholder]="'WEBHOOK_DIALOG.PLACEHOLDERS.PASSWORD'|translate"
                               formControlName="password">
                    </div>
                    }
                    @case(authTypes.JWT) {
                    <div class="flex-row start-center gap-8">
                        <textarea class="ui-input"
                                  [placeholder]="'WEBHOOK_DIALOG.PLACEHOLDERS.TOKEN'|translate"
                                  formControlName="token">
                        </textarea>
                    </div>
                    }
                    }
                </ng-container>
            </div>
            }
            @case(webhookTabs.Body) {
            <div class="flex-col h-100 w-100 gap-8 mt-16">
                <div class="virtual-scroll-container w-100"
                     [class.invalid]="form.get('body').invalid">
                    <section class="virtual-scroll-table w-100">
                        <header>
                            <div class="col flex">
                                <div class="inner">
                                    {{ 'WEBHOOK_DIALOG.BODY'|translate }}
                                </div>
                            </div>
                            <div class="col flex">
                                <div class="inner">

                                </div>
                            </div>
                            <div class="col flex"
                                 style="max-width: 50px;">
                                <div class="inner">
                                </div>
                            </div>
                        </header>
                        <div class="w-100"
                             style="height:200px">
                            <ngx-monaco-editor (onInit)="onEditorInit($event)"
                                               [options]="editorOptions()"
                                               class="w-100 h-100"
                                               formControlName="body">

                            </ngx-monaco-editor>
                        </div>
                    </section>

                </div>
            </div>
            }
            @case(webhookTabs.Options) {
            <div class="flex-col h-100 w-100 gap-8">
                <options-table [paramsControls]="getAllowOriginsControls"
                               [title]="'WEBHOOK_DIALOG.ALLOW_ORIGINS'"
                               (deleteParamsOutput)="deleteAllowOrigins($event)"
                               (addParamsOutput)="addAllowOrigins()">
                </options-table>

                <options-table [paramsControls]="getAllowIpsControls"
                               [title]="'WEBHOOK_DIALOG.ALLOW_IPS'"
                               (deleteParamsOutput)="deleteAllowIps($event)"
                               (addParamsOutput)="addAllowIps()">
                </options-table>
            </div>
            }
            }
        </div>
    </div>

    <div class="footer flex-row space-between-center">
        <span class="footer-hint">
            @if (selectedTabSig() === webhookTabs.Body) {
                {{ 'WEBHOOK_DIALOG.BODY_HINT' | translate }}
            } @else if (selectedTabSig() === webhookTabs.QueryParams) {
                {{ 'WEBHOOK_DIALOG.KV_HINT' | translate }}
            }
        </span>
        <div class="flex-row end-center gap-8">
            <ui-button type="default"
                       [text]="'COMMON.CANCEL'|translate"
                       (clickAction)="close()">
            </ui-button>

            <ui-button type="primary"
                       [text]="data?.webhookId ? ('COMMON.SAVE'|translate) : ('COMMON.CREATE'|translate)"
                       [loading]="selectIsSavingSig()"
                       (clickAction)="save()">
            </ui-button>
        </div>
    </div>
</div>